import { inject, Injectable } from '@angular/core';
import {
  getStatusText,
  InMemoryDbService,
  ParsedRequestUrl,
  RequestInfo,
  RequestInfoUtilities,
  ResponseOptions,
  STATUS,
} from 'angular-in-memory-web-api';
import { Store } from '@ngrx/store';
import { featureFlagFeature } from '@store';
import { businessAcccountMock, serviceAcccountMock } from './mock-data';

const businessAccounts = [businessAcccountMock];
const serviceAccounts = [serviceAcccountMock];

@Injectable({
  providedIn: 'root',
})
export class MockService implements InMemoryDbService {
  store = inject(Store);

  mockApiEnabled = false;

  constructor() {
    this.store.select(featureFlagFeature.selectFeatureFlagState).subscribe({
      next: (featureFlags) => {
        this.mockApiEnabled = featureFlags['mockApiFeature'] ?? false;
      },
    });
  }

  createDb() {
    return { businessAccounts, serviceAccounts };
  }

  get(reqInfo: RequestInfo) {
    const collectionName = reqInfo.collectionName;
    if (collectionName === 'businessAccounts') {
      return this.getBusinessAccounts(reqInfo);
    }

    if (collectionName === 'serviceAccounts') {
      return this.getServiceAccounts(reqInfo);
    }

    return undefined;
  }

  private getBusinessAccounts(reqInfo: RequestInfo) {
    return reqInfo.utils.createResponse$(() => {
      const id = reqInfo.id;
      const data = id == null ? reqInfo.collection : reqInfo.utils.findById(reqInfo.collection, id);

      const options: ResponseOptions = data
        ? { body: id != null ? data : { content: data, totalElements: data.length, hasNext: false }, status: STATUS.OK }
        : { body: { message: `cannot find by id: ${id}`, errorCode: 'not-found' }, status: STATUS.NOT_FOUND };
      return this.finishOptions(options, reqInfo);
    });
  }

  private getServiceAccounts(reqInfo: RequestInfo) {
    return reqInfo.utils.createResponse$(() => {
      const id = reqInfo.id;
      const data = id == null ? reqInfo.collection : reqInfo.utils.findById(reqInfo.collection, id);

      const options: ResponseOptions = data
        ? { body: id != null ? data : { content: data, totalElements: data.length, hasNext: false }, status: STATUS.OK }
        : { body: { message: `cannot find by id: ${id}`, errorCode: 'not-found' }, status: STATUS.NOT_FOUND };
      return this.finishOptions(options, reqInfo);
    });
  }

  private finishOptions(options: ResponseOptions, { headers, url }: RequestInfo) {
    options.statusText = options.status == null ? undefined : getStatusText(options.status);
    options.headers = headers;
    options.url = url;
    return options;
  }

  parseRequestUrl(url: string, utils: RequestInfoUtilities): ParsedRequestUrl {
    if (!this.mockApiEnabled) {
      return utils.parseRequestUrl(url);
    }

    const newUrl = url.includes('service-accounts')
      ? '/api/serviceAccounts' + url.split('service-accounts')[1]
      : url.replace(/\/v1\/business-accounts/, '/api/businessAccounts');
    const parsed = utils.parseRequestUrl(newUrl);
    return parsed;
  }
}
